/* eslint-disable max-len */
import React from 'react';

const SuccessfulMonitor: React.FC<object> = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="8"
                cy="8"
                r="8"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM5.5547 6.83205L8 5.20185L10.4453 6.83205C10.9048 7.1384 11.5257 7.01423 11.832 6.5547C12.1384 6.09517 12.0142 5.4743 11.5547 5.16795L8.5547 3.16795C8.2188 2.94402 7.7812 2.94402 7.4453 3.16795L4.4453 5.16795C3.98577 5.4743 3.8616 6.09517 4.16795 6.5547C4.4743 7.01423 5.09517 7.1384 5.5547 6.83205ZM5.5547 11.8321L8 10.2018L10.4453 11.8321C10.9048 12.1384 11.5257 12.0142 11.832 11.5547C12.1384 11.0952 12.0142 10.4743 11.5547 10.1679L8.5547 8.16795C8.2188 7.94402 7.7812 7.94402 7.4453 8.16795L4.4453 10.1679C3.98577 10.4743 3.8616 11.0952 4.16795 11.5547C4.4743 12.0142 5.09517 12.1384 5.5547 11.8321Z"
                fill="#00B86B"
            />
        </svg>
    );
};

export default SuccessfulMonitor;